package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.*

class AnalyticsRepository(private val httpClient: HttpClient) {
    suspend fun getAnalytics(workplaceId: Long): Result<AnalyticsDto> = runCatching {
        httpClient.get("workplaces/$workplaceId/analytics").body()
    }
}
